import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import WindscreensPage from "@/pages/WindscreensPage";
import BreakdownAssistPage from "@/pages/BreakdownAssistPage";
import TermsPage from "@/pages/TermsPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminJobForm from "@/pages/admin/AdminJobForm";
import AdminJobDetail from "@/pages/admin/AdminJobDetail";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminStock from "@/pages/admin/AdminStock";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminAging from "@/pages/admin/AdminAging";
import AdminRoutes from "@/pages/admin/AdminRoutes";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminPerformance from "@/pages/admin/AdminPerformance";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCustomerForm from "@/pages/admin/AdminCustomerForm";
import AdminCustomerDetail from "@/pages/admin/AdminCustomerDetail";
import AdminCreditNotes from "@/pages/admin/AdminCreditNotes";
import AdminCreditNoteForm from "@/pages/admin/AdminCreditNoteForm";
import AdminCreditNoteDetail from "@/pages/admin/AdminCreditNoteDetail";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminInvoiceForm from "@/pages/admin/AdminInvoiceForm";
import { AdminBrokers, AdminBrokerForm } from "@/pages/admin/AdminBrokers";
import { AdminClients, AdminClientForm } from "@/pages/admin/AdminClients";
import AdminInsurers from "@/pages/admin/AdminInsurers";
import ClientPortalPage from "@/pages/ClientPortalPage";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import AdminInvoiceAudit from "@/pages/admin/AdminInvoiceAudit";
import TeamLayout from "@/pages/team/TeamLayout";
import TeamJobs from "@/pages/team/TeamJobs";
import TeamJobDetail from "@/pages/team/TeamJobDetail";
import TeamStock from "@/pages/team/TeamStock";
import JobCardStepper from "@/pages/team/JobCardStepper";
import AdminCompletionQueue from "@/pages/admin/AdminCompletionQueue";
import PreFitmentSignOffPage from "@/pages/PreFitmentSignOffPage";
import LoginPage from "@/pages/LoginPage";
import SetupInvitePage from "@/pages/SetupInvitePage";
import { ClientLayout, ClientJobs, ClientJobDetail, ClientDocuments } from "@/pages/client/ClientPortal";
import AdminAwaitingScheduling from "@/pages/admin/AdminAwaitingScheduling";
import AdminScheduleChanges from "@/pages/admin/AdminScheduleChanges";
import { AuthProvider } from "@/lib/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/setup/:token" element={<SetupInvitePage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/windscreens" element={<WindscreensPage />} />
          <Route path="/breakdown-assist" element={<BreakdownAssistPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<ProtectedRoute allowed={["admin"]}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="jobs/new" element={<AdminJobForm />} />
            <Route path="jobs/:id" element={<AdminJobDetail />} />
            <Route path="jobs/:id/edit" element={<AdminJobForm />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="routes" element={<AdminRoutes />} />
            <Route path="stock" element={<AdminStock />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="aging" element={<AdminAging />} />
            <Route path="performance" element={<AdminPerformance />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="customers/new" element={<AdminCustomerForm />} />
            <Route path="customers/:id" element={<AdminCustomerDetail />} />
            <Route path="customers/:id/edit" element={<AdminCustomerForm />} />
            <Route path="credit-notes" element={<AdminCreditNotes />} />
            <Route path="credit-notes/new" element={<AdminCreditNoteForm />} />
            <Route path="credit-notes/:id" element={<AdminCreditNoteDetail />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="brokers" element={<AdminBrokers />} />
            <Route path="brokers/new" element={<AdminBrokerForm />} />
            <Route path="brokers/:id" element={<AdminBrokerForm />} />
            <Route path="insurers" element={<AdminInsurers />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="clients/new" element={<AdminClientForm />} />
            <Route path="clients/:id" element={<AdminClientForm />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="invoices/new" element={<AdminInvoiceForm />} />
            <Route path="invoices/:id" element={<AdminInvoiceForm />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="audit-log" element={<AdminAuditLog />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="change-password" element={<AdminChangePassword />} />
            <Route path="invoice-audit" element={<AdminInvoiceAudit />} />
            <Route path="awaiting-scheduling" element={<AdminAwaitingScheduling />} />
            <Route path="schedule-changes" element={<AdminScheduleChanges />} />
            <Route path="completion-queue" element={<AdminCompletionQueue />} />
          </Route>
          <Route path="/client" element={<ProtectedRoute allowed={["client", "admin"]}><ClientLayout /></ProtectedRoute>}>
            <Route index element={<ClientJobs />} />
            <Route path="jobs/:id" element={<ClientJobDetail />} />
            <Route path="documents" element={<ClientDocuments />} />
          </Route>
          <Route path="/team" element={<ProtectedRoute allowed={["fitter", "admin"]}><TeamLayout /></ProtectedRoute>}>
            <Route index element={<TeamJobs />} />
            <Route path="jobs/:id" element={<TeamJobDetail />} />
            <Route path="jobs/:id/jobcard" element={<JobCardStepper />} />
            <Route path="stock" element={<TeamStock />} />
          </Route>
          <Route path="/sign/:token" element={<PreFitmentSignOffPage />} />
          <Route path="/portal/:token" element={<ClientPortalPage />} />
        </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
